import script from "./SocialImpact.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialImpact.vue?vue&type=script&setup=true&lang=js"

import "./SocialImpact.vue?vue&type=style&index=0&id=03079e5e&scoped=true&lang=css"

import exportComponent from "/home/appiah/Documents/projects/greenfield/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03079e5e"]])

export default __exports__